import {
  BANK_DATA_LOADING,
  BANK_DATA_SUCCESS,
  BANK_DATA_FAILED,
  SAVE_BANK_DATA_LOADING,
  SAVE_BANK_DATA_SUCCESS,
  SAVE_BANK_DATA_FAILED,
  INSTANT_BANK_DATA_SUCCESS,
  INSTANT_BANK_DATA_LOADING,
  INSTANT_BANK_DATA_FAILED,
  UPLOAD_FILE_LOADING,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILED
} from "../Constants/bankVerificationConstants";

export const bankDataReducer = (state = { bankData: [] }, action) => {
  switch (action.type) {
    case BANK_DATA_LOADING:
      return { loading: true, bankData: [] };
    case BANK_DATA_SUCCESS:
      return { loading: false, bankData: action.payload };
    case BANK_DATA_FAILED:
      return { loading: false, error: action.bankData };
    default:
      return state;
  }
};

export const saveBankDataReducer = (state = { saveBankValue: [] }, action) => {
    switch (action.type) {
      case SAVE_BANK_DATA_LOADING:
        return { loading: true, saveBankValue: [] };
      case SAVE_BANK_DATA_SUCCESS:
        return { loading: false, saveBankValue: action.payload };
      case SAVE_BANK_DATA_FAILED:
        return { loading: false, error: action.saveBankValue };
      default:
        return state;
    }
  };

  export const instantBankDataReducer = (state = { instantBank: [] }, action) => {
    switch (action.type) {
      case INSTANT_BANK_DATA_LOADING:
        return { loading: true, instantBank: [] };
      case INSTANT_BANK_DATA_SUCCESS:
        return { loading: false, instantBank: action.payload };
      case INSTANT_BANK_DATA_FAILED:
        return { loading: false, error: action.instantBank };
      default:
        return state;
    }
  };

  export const uploadBankReducer = (state = { uploadBankData: [] }, action) => {
    switch (action.type) {
      case UPLOAD_FILE_LOADING:
        return { loading: true, uploadBankData: [] };
      case UPLOAD_FILE_SUCCESS:
        return { loading: false, uploadBankData: action.payload };
      case UPLOAD_FILE_FAILED:
        return { loading: false, error: action.uploadBankData };
      default:
        return state;
    }
  };
